import { useState } from "react";
import { Box, Text, Button, Input } from "@chakra-ui/react";
import { toaster } from "./atoms/toaster";

interface ReceiptUploaderProps {
  transactionId?: string;
}

export const ReceiptUploader = ({ transactionId }: ReceiptUploaderProps) => {
  const [file, setFile] = useState<File | null>(null);
  const [reference, setReference] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const upload = async () => {
    if (!file) return;

    setIsUploading(true);

    try {
      const form = new FormData();
      form.append("file", file);
      if (transactionId) {
        form.append("transactionId", transactionId);
      }

      const res = await fetch("/api/receipts/upload-receipts", {
        method: "POST",
        body: form,
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Failed to upload receipt");
      }

      setReference(data.reference);
      toaster.create({
        title: "Success",
        description: "Receipt uploaded successfully!",
        type: "info",
        duration: 3000,
        closable: true,
      });
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to upload receipt";

      toaster.create({
        title: "Error",
        description: errorMessage,
        type: "error",
        duration: 5000,
        closable: true,
      });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Box py={4}>
      <Input
        type='file'
        accept='image/jpeg,image/png,image/webp'
        onChange={(e) => {
          const files = e.target.files;
          setFile(files ? files[0] : null);
        }}
        disabled={isUploading}
        mb={4}
      />

      <Button
        colorPalette='blue'
        onClick={upload}
        loading={isUploading}
        disabled={!file || isUploading}
        width='full'
      >
        {isUploading ? "Uploading..." : "Upload Receipt"}
      </Button>

      {reference && (
        <Text mt={4} color='green.500'>
          Receipt uploaded!{" "}
          <a
            href='#'
            onClick={async (e) => {
              e.preventDefault();
              const res = await fetch(
                `/api/get-receipt-url?reference=${reference}`,
              );
              const data = await res.json();
              if (res.ok) {
                window.open(data.url, "_blank");
              } else {
                toaster.create({
                  title: "Error",
                  description: data.error || "Could not get receipt URL",
                  type: "error",
                  duration: 5000,
                  closable: true,
                });
              }
            }}
            style={{ color: "#3182CE", textDecoration: "underline" }}
          >
            View Receipt
          </a>
        </Text>
      )}
    </Box>
  );
};
